module.exports = __webpack_public_path__ + "img/wifiacc.f2bc5b0b.png";